<template>
  <div>
    <v-app-bar
      class="footer d-none d-md-flex"
      elevation="3"
      color="rgba(255,255,255,0.9)"
    >
    <v-spacer></v-spacer>
      <ul v-for="item in footerItems" :key="item.id">
        <li class="footer-item">{{ item.content }}</li>
      </ul>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-app-bar
      class="footer d-md-none"
      elevation="3"
      color="rgba(255,255,255,0.9)"
    >
    <v-spacer></v-spacer>
    <v-menu
        middle
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            color="transparent"
            elevation="0"
          >
            <p class="mini-footer-button">動物取扱業者申請情報</p>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="item in footerItems"
            :key="item.id"
            @click="() => {}"
            disabled="true"
          >
            <v-list-item-title>
              <p class="mini-footer-items">{{ item.content }}</p>
              </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data() {
    return {
      footerItems: [
        {id:1, content:'【動物取扱業者申請情報】'},
        {id:2, content:'氏名または名称:Dog Salon Free'},
        {id:3, content:'種別:保管'},
        {id:4, content:'動物取扱責任者:町田 佐絵'},
        {id:5, content:'登録番号:長野県佐久保健所'},
        {id:6, content:'指令6第5-01038212号'},
        {id:7, content:'登録年月日:2024/9/24'},
        {id:8, content:'有効期限の末日:2029/9/23'},
      ]
    }
  }
}
</script> 

<style lang="scss" scoped>
  .footer {
    // padding: 10px;
    // background: #dee;
  }
  .footer-item {
    color: rgba($dark-font-color, 0.5);
    // text-align: right;
    font-size: 10px;
    // letter-spacing: 1.5px;
    // line-height: 0.5rem;
    // padding: 5px 0;
  }
  .v-menu {
    margin: 0 auto;
  }
  .mini-footer-button {
    font-size: 2vw;
    color: rgba($dark-font-color, 0.5);
  }
  .mini-footer-items {
    font-size: 2vw;
  }
</style>